import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-item-list-panel-large" }
const _hoisted_2 = { class: "p-item-list-panel-large__content" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-item-list-panel-large__info" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "p-item-list-panel-large__id" }
const _hoisted_8 = { class: "p-item-list-panel-large__item__details" }
const _hoisted_9 = { class: "p-item-list-panel-large__point" }
const _hoisted_10 = {
  key: 0,
  class: "p-item-list-panel-large__point__discount_rate"
}
const _hoisted_11 = { class: "p-item-list-panel-large__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_ItemSpecs = _resolveComponent("ItemSpecs")!
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: '/product-details/?id=' + _ctx.premiumId,
        class: "p-item-list-panel-large__thumbnail"
      }, [
        _createElementVNode("img", {
          style: _normalizeStyle(_ctx.setOpacity),
          src: _ctx.thumbnails[0].path
        }, null, 12, _hoisted_4)
      ], 8, _hoisted_3),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.status)
          ? (_openBlock(), _createBlock(_component_TextLabel, {
              key: 0,
              color: { border: _ctx.color, content: '#fff' },
              reverse: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.status), 1)
              ]),
              _: 1
            }, 8, ["color"]))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: '/product-details/?id=' + _ctx.premiumId,
          class: "p-item-list-panel-large__name"
        }, _toDisplayString(_ctx.name), 9, _hoisted_6),
        _createElementVNode("p", _hoisted_7, "商品NO." + _toDisplayString(_ctx.premiumId), 1),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.showSpecs)
            ? (_openBlock(), _createBlock(_component_ItemSpecs, {
                key: 0,
                specs: _ctx.getSpecs(_ctx.options),
                class: "p-item-list-panel-large__item__specs"
              }, null, 8, ["specs"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_PointNotation, {
            point: _ctx.point,
            "font-size": _ctx.itemPointFontSize,
            unit: _ctx.unit,
            "sign-is-exists": false
          }, null, 8, ["point", "font-size", "unit"]),
          (_ctx.discountRate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "（" + _toDisplayString(_ctx.discountRate) + "%OFF）", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("template", null, [
          (_ctx.isCart)
            ? (_openBlock(), _createBlock(_component_ButtonMain, {
                key: 0,
                tag: "a",
                href: "/cart-details/",
                kind: "secondary"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("カートを確認", -1)
                ])),
                _: 1,
                __: [1]
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("template", null, null, -1)),
        _createElementVNode("a", {
          href: "javascript:void(0);",
          class: "p-item-list-panel-large__delete",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitDelete && _ctx.emitDelete(...args)))
        }, "削除する")
      ])
    ])
  ]))
}